/**
 * @overview Typography mixins for headings, paragraphs etc.
 */

import { css } from 'styled-components';
import { settings } from '../settings/index';

import {
  azoSansRegular,
  azoSansBold,
  azoSansLight,
  elaineRegular,
  brandonGrotesqueBold,
  brandonGrotesqueRegular,
  garamondRegular,
  garamondSemibold,
  garamondRegularItalic,
  garamondSemiboldItalic,
} from '../settings/fonts.css';

const {
  colors: { color },
  mediaqueries: { mobileDown, tabletLandscapeDown, tabletLandscapeUp, tabletPortraitDown, tabletPortraitUp },
} = settings;

const {
  sizing: { fontsize },
  shadows: { textShadowDefault },
} = settings;

export const heading1 = css`
  ${brandonGrotesqueRegular}
  font-size: ${fontsize(11)};

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(11)};
  }

  @media ${tabletPortraitDown} {
    font-size: ${fontsize(10)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(9)};
  }
`;

export const heading2 = css`
  ${brandonGrotesqueRegular}
  font-size: ${fontsize(9)};
  text-transform: uppercase;

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(10)};
  }

  @media ${tabletPortraitDown} {
    font-size: ${fontsize(9)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(8)};
  }
`;

export const heading5 = css`
  ${brandonGrotesqueRegular}
  font-size: ${fontsize(5)};
  letter-spacing: 0.2em;

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(4)};
  }

  @media ${tabletPortraitDown} {
    font-size: ${fontsize(4)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(4)};
  }
`;

export const placeholderText = css`
  ${azoSansRegular}
  font-size: ${fontsize(7)};

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(6)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(2)};
  }
`;

export const buttonText = css`
  ${azoSansBold}
  font-size: ${fontsize(5)};

  @media ${mobileDown} {
    font-size: ${fontsize(3)};
  }
`;

export const inputText = css`
  ${azoSansRegular}
  font-size: ${fontsize(6)};
  line-height: 2rem;
  text-shadow: ${textShadowDefault};

  @media ${mobileDown} {
    font-size: ${fontsize(2)};
  }
`;

export const inputTextLabel = css`
  ${azoSansRegular}
  left: 1rem;
  font-size: ${fontsize(3)};
  line-height: 1.5rem;

  @media ${mobileDown} {
    font-size: ${fontsize(2)};
  }
`;

export const legal = css`
  ${azoSansLight}
  font-size: ${fontsize(1)};
`;

export const thankYouHeadline = css`
  ${azoSansRegular}
  font-size: ${fontsize(7)};
  line-height: 2rem;

  @media ${tabletLandscapeDown} {
    font-size: 1.75rem;
  }

  @media ${mobileDown} {
    font-size: ${fontsize(6)};
    line-height: 1.875rem;
  }
`;

export const thankYouSubHeadline = css`
  ${azoSansLight}
  font-size: 1.625rem;
  line-height: 2rem;

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(5)};
  }
`;

export const heroDescription = css`
  ${garamondRegular}
  font-size: ${fontsize(8)};
  color: ${color(`gray`)};

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(7)};
  }

  @media ${tabletPortraitDown} {
    font-size: ${fontsize(7)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(7)};
  }
`;

export const linkButtonText = css`
  ${brandonGrotesqueBold}
  font-size: ${fontsize(8)};
  color: ${color(`black`)};
  text-transform: uppercase;
  letter-spacing: 0.2em;
  padding-bottom: 0.2em;

  &:hover {
    color: ${color(`teal`)};
  }

  @media ${tabletLandscapeDown} {
    font-size: ${fontsize(7)};
  }

  @media ${tabletPortraitDown} {
    font-size: ${fontsize(6)};
  }

  @media ${mobileDown} {
    font-size: ${fontsize(5)};
  }
`;
